var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hr',{staticClass:"h-0 m-0 border-0 border-solid border-b-2",class:_vm.borderColorClass,attrs:{"role":"presentation"}})}
var staticRenderFns = []

export { render, staticRenderFns }